import { Component } from 'react';
import { CaseStudySequence, SimulationEhrSequence } from 'models/ui';
import { ChartsInvolved, MultiLine } from 'components/common';
import { ELSTab, ELSTabGroup } from 'components/common/els';
import { AssignmentType } from 'models/enum';

export enum Tabs {
  INSTRUCTIONS = 0,
  CHARTS_INVOLVED = 1
}

interface PhasesDetailViewProps {
  sequence: CaseStudySequence | SimulationEhrSequence;
  assignmentType: string;
}

interface PhasesDetailViewStates {
  activeTab: number;
}

class PhasesDetailView extends Component<PhasesDetailViewProps, PhasesDetailViewStates> {
  static displayName = 'PhasesDetailView';

  constructor(props) {
    super(props);
    this.state = {
      activeTab: Tabs.INSTRUCTIONS
    };
  }

  handleTabGroupClick = (tabIndex) => this.setState({ activeTab: tabIndex });

  render() {
    const {assignmentType, sequence} = this.props;
    return (
      <div>
        <h1 className="u-els-margin-top-3x u-els-margin-bottom-2x">{sequence.content.title}</h1>
        <ELSTabGroup onChangeActiveIndex={this.handleTabGroupClick} activeIndex={this.state.activeTab}>
          <ELSTab title="Instructions" />
          {assignmentType !== AssignmentType.SIMULATION && <ELSTab title="Charts involved" />}
        </ELSTabGroup>
        {this.state.activeTab === Tabs.INSTRUCTIONS && (
          <div data-qa="qa-instruction-tab">
            <MultiLine text={sequence.content?.instruction} />
          </div>
        )}
        {assignmentType !== AssignmentType.SIMULATION && this.state.activeTab === Tabs.CHARTS_INVOLVED && <ChartsInvolved charts={sequence.content?.chartsInvolved} />}
      </div>
    );
  }
}

export default PhasesDetailView;
